import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_77bnfe2w2i: FaireBrandEntity = {
  token: "b_77bnfe2w2i",
  type: "brand",
  name: "Rae Mode",
  avatarUrl:
    "https://cdn.faire.com/fastly/4d2ca2f0d4a0d031bc89c4a06f6b49271c240569720b4d5e0eab7af9f83839c6.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/c74151ff283f171f34c1fff097e43ccaa9e6098b898cf0a7808edcc663cbe13b.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/4d2ca2f0d4a0d031bc89c4a06f6b49271c240569720b4d5e0eab7af9f83839c6.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/c74151ff283f171f34c1fff097e43ccaa9e6098b898cf0a7808edcc663cbe13b.jpeg",
  location: "Los Angeles, CA, USA",
  minimumOrderDollars: 100,
  rating: 4.7,
  reviewCount: 368,
  isTopShop: true,
  isInsider: true,
  description:
    'Although cliché, RAE MODE started from the ground up.\n\nFounded in 2017 and starting the fashion journey with only two employees, RAE MODE has now become one of the leading wholesale brands in the "athleisure" industry. \n\nWith failures and hardships from previous businesses, our CEO has been successful with the lessons she learned. At a young age, she experienced the deterioration of trust between partners in her previous business when the partners stole everything she had. Thus, our core philosophy is to be truthful, trustworthy, and fair in our B2B and B2C services.\n\nRAE MODE was founded when our CEO saw the difficulty her mother was having when shopping for leggings. With a limited variety for those with big proportions and different sizing for each store, our CEO dedicated herself to change the strenuous shopping experience into a happy one.\n\nUnderstanding the difficult customer journey, our brand is an inclusive, one-stop wholesale store that sells diverse styles ranging from casual to active wear in regular and plus sizes.',
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:44:45.212Z",
    importedBy: "entity-db-cli",
  },
};
